import { BKJButton, BKJTextInput, Flex } from '@bookjane2/bookjane-design-library';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { JaneGridSelect } from 'components/JaneGridSelect';
import { QuerySwitch } from 'components/QuerySwitch';
import { useAssignToAgencyTeamMemberFormContext } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/AssignToAgencyTeamMemberView.form.context';
import {
  FetchAgencyTeamMembersDataContext,
  useFetchAgencyTeamMembersDataContext,
} from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/FetchAgencyTeamMembers.data.context';
import { useSendToAgencyTeamMemberViewPropsContext } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/views/SelectAgencyTeamMemberView/SendToAgencyTeamMemberView.props.context';
import { RequestTeamMemberWrapper } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesView.styled';
import { MainTitle } from 'modals/TimeOffModal/TimeOffModalView.styled';
import { TotalAvailableJanesText } from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftModal/src/views/CreateShiftModal.styled';
import { FC, Fragment } from 'react';
import { useTranslation } from 'hooks/useTranslation';

function RenderJanes() {
  const { onChange, values } = useAssignToAgencyTeamMemberFormContext();
  const { loadMore } = useFetchAgencyTeamMembersDataContext();
  const { t } = useTranslation();

  return (
    <JaneGridSelect
      edgeCaseType="AssignToTeamMember"
      paginationType="InfiniteScroll"
      type="Single"
      label={t('shift_modal:SELECT')}
      name="janeId"
      dataPath="requestAllJanes.nodes"
      value={[values.janeId]}
      context={FetchAgencyTeamMembersDataContext}
      onChange={onChange}
      loadMore={loadMore}
      pageInfoDataPath="requestAllJanes.pageInfo"
      errorText={t('errors:SELECT_AGENCY_TEAM_MEMBER_ERROR_MSG')}
    />
  );
}

const AssignToAgencyTeamMemberHeader: FC = () => {
  const { t } = useTranslation();
  const { data } = useFetchAgencyTeamMembersDataContext();
  const totalCount = data?.totalCount || 0;
  return (
    <Flex justifyContent="space-between" alignItems="baseline">
      <MainTitle>{t('shift_modal:ASSIGN_TEAM_MEMBER')}</MainTitle>
      {totalCount > 0 && (
        <TotalAvailableJanesText>
          {totalCount} {t('shift_modal:AVAILABLE')}
        </TotalAvailableJanesText>
      )}
    </Flex>
  );
};

export const SelectAgencyTeamMemberViewComponent: FC = () => {
  const { t } = useTranslation();
  const { values: formValues, isDisabled } = useAssignToAgencyTeamMemberFormContext();
  const { values, onChange } = useFetchAgencyTeamMembersDataContext();
  const { goToSummaryView } = useSendToAgencyTeamMemberViewPropsContext();

  return (
    <Fragment>
      <Flex flexDirection="column" padding="12px 32px 0 32px" gap="4px">
        <AssignToAgencyTeamMemberHeader />

        <BKJTextInput
          leftIconProps={{ iconName: 'Search' }}
          name="byMultipleFields"
          placeholder={t('shift_modal:SEARCH_MEMBER')}
          value={values.byMultipleFields}
          onChange={onChange}
        />
      </Flex>
      <RequestTeamMemberWrapper
        flexDirection="column"
        padding="24px 32px"
        flex="1"
        height="100%"
        width="100%"
      >
        <QuerySwitch component={RenderJanes} context={FetchAgencyTeamMembersDataContext} />
      </RequestTeamMemberWrapper>
      <BKJSideModalFooter justifyContent="space-between">
        <div>{`${t('shift_modal:SELECTED')}: ${formValues.janeId ? 1 : 0}/1`}</div>
        <BKJButton
          width="180px"
          variant="PurpleSolid"
          onClick={goToSummaryView}
          disabled={isDisabled}
        >
          {t('shift_modal:NEXT')}
        </BKJButton>
      </BKJSideModalFooter>
    </Fragment>
  );
};
